/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計タブの子票行で選べる「項目」「リポジトリ」の候補一覧。どちらも Backlog の子票に書く値そのものなので翻訳せず、表示名を値として持つ
 * @graph-connects none
 */

/** 「項目」の候補（子票の作業区分）。 @graph-connects none */
export const CHILD_TICKET_ITEMS: readonly string[] = [
  '設計',
  '調査',
  'フロント',
  'API',
  'API（spec）',
  'batch',
  'batch（spec）',
  'migration',
  'domain',
  'domain（spec）',
  'SQL',
  'S3',
  'インフラ',
  'DevOps',
  'その他',
  'アプリボーナス',
  'dstAPI',
  'config',
  '影響範囲調査',
];

/** 「リポジトリ」の候補。 @graph-connects none */
export const CHILD_TICKET_REPOSITORIES: readonly string[] = [
  'air-closet(APP)',
  'air-closet-ssr',
  'air-closet-api',
  'air-closet-console',
  'air-closet-styling-console',
  'air-closet-styling-api',
  'air-closet-node-batch',
  'air-closet-tsnode-batch',
  'air-closet-next-warehouse',
  'air-closet-back-office-api',
  'ac-web-static',
  'ac-web-static2',
  'air-closet-infrastructure',
  'cella-front',
  'cella-api',
  'rem-api',
  'air-closet-migration',
  'air-closet-batch-infrastructure',
  'acf-web',
  'pickss-migration',
  'Arthur',
  'restore-rds',
  'cella-migration',
  'air-closet-console-web',
  'ac-serverless-api',
  'bridge-ui-mobile',
  'bridge-ui-web',
  'bridge-api',
  'e2e-web',
  'acm-api',
  'acm-web',
  'acm-admin-api',
  'acm-admin-web',
  'disney-api',
  'disney-web',
  'phoenix-item',
  'phoenix-config',
  'phoenix_infrastructure',
  'bridge-infrastructure',
  'disney-infrastructure',
  'phoenix-order',
  'air-closet-config',
  'occasion-dress-web',
  'occasion-dress-web-static',
  'occasion-dress-backend',
  'occasion-dress-infrastructure',
  'phoenix-console-frontend',
  'phoenix-console-backend',
  'phoenix-account',
  'acm-docs',
  'acm-infra',
  'acm-tv',
  'bridge-reporter',
  'bridge-reporter-app',
  'bridge-serverless',
  'cella-app',
  'payment',
  'payment-service',
  'phoenix_base',
  'phoenix-styling',
  'ecosale-shopify-web',
  'ecosale-backend',
  'air-closet-mens',
];

/**
 * 文字列配列を Picker の候補へ変換する（値 = 表示名）。
 * @graph-connects none
 */
export function toPickerOptions(values: readonly string[]): { value: string; label: string }[] {
  return values.map((value) => ({ value, label: value }));
}
